import { isBrowser } from "../../utils/environmentDetection/library";
import {
    ALL_SHORTCUTS_BAR_LINKS,
    getDefaultShortcutsBarLinks,
} from "./constants";
import { ShortcutBarItem, StoredShortcutItem } from "./interface";

const localStorageKey = "CBC_SHORTCUTS_BAR_ITEMS";

export const getUserSelections = (): ShortcutBarItem[] => {
    if (isBrowser() && window?.localStorage) {
        const storedItems: string | null =
            window.localStorage.getItem(localStorageKey);

        if (storedItems) {
            const parsedItems = JSON.parse(storedItems) as ShortcutBarItem[];

            const selectedItems = ALL_SHORTCUTS_BAR_LINKS.filter((item) => {
                return parsedItems.some((parsedItem) => {
                    return item.label === parsedItem.label;
                });
            }).map((item, i) => {
                return item;
            });

            return selectedItems;
        }
    }

    return getDefaultShortcutsBarLinks();
};

export const setUserSelections = (items: StoredShortcutItem[]): void => {
    const storedItems = items?.map((item) => {
        const itemLabel: StoredShortcutItem = {
            label: item.label,
        };
        return itemLabel;
    });

    if (isBrowser() && window?.localStorage) {
        localStorage.setItem(localStorageKey, JSON.stringify(storedItems));
    }
};

export const resetUserSelections = (): void => {
    if (isBrowser() && window?.localStorage) {
        window.localStorage.removeItem(localStorageKey);
    }
};
